import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { useIntl } from 'react-intl';

import { H3 } from '@/components/Heading';
import { NextImage } from '@/components/Image';
import { GoToLink } from '@/components/UI/Links/GoToLink';
import NavLink from '@/components/UI/Links/NavLink';

import RoutePath from '@/constants/route-path';
import { MonthAction } from '@/models/cms/MonthAction';
import { StrapiUtilsService } from '@/services/StrapiUtilsService';

type MonthActionItemProps = {
    data: MonthAction;
};

export const MonthActionCard = (props: MonthActionItemProps) => {
    const intl = useIntl();
    const { data } = props;

    const { shortDescription, title, slug } = data.attributes;
    const imageAttributes = data.attributes.image.data.attributes;
    const image = imageAttributes.formats?.medium || imageAttributes;
    const alternativeText = imageAttributes.alternativeText || title;
    const fullSiteLink = RoutePath.MonthActions.concat('/', slug);

    return (
        <Grid
            templateColumns={{
                md: 'auto 1fr'
            }}
            gap={8}
            borderRadius={21}
            borderColor="grey.200"
            borderWidth={1}
            px={27}
            py={29}
        >
            {image?.url && (
                <Flex
                    borderRadius={19}
                    overflow="hidden"
                    maxW={{ md: '100%' }}
                    maxH={{ md: 180 }}
                    w={{ md: 210 }}
                    justifyContent="center"
                >
                    <NextImage
                        src={StrapiUtilsService.updateUploadsUrl(image.url)}
                        alt={alternativeText}
                        width={image?.width || 840}
                        height={image?.height || 720}
                        justifyContent="center"
                        display="flex"
                        style={{
                            objectFit: 'contain'
                        }}
                    />
                </Flex>
            )}
            <Box>
                <H3 mb={3.5} fontWeight="semibold">
                    <NavLink href={fullSiteLink}>{title}</NavLink>
                </H3>
                <Text>{shortDescription}</Text>
                <GoToLink flexShrink={0} href={fullSiteLink} mt={4} display="inline-block">
                    {intl.formatMessage({ id: 'more' })}
                </GoToLink>
            </Box>
        </Grid>
    );
};
